<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回患者列表
                </div>
            </div>
            <div class="title">{{ viewTitle }}</div>
        </div>

        <div class="form_box ill_form_box">
            <el-form
                    :model="form"
                    :rules="rules"
                    size="medial"
                    ref="form"
                    label-width="200px"
            >
                <el-form-item label="姓名：" prop="name">
                    {{ form.name }}
                    <span style="color: blue"> ({{ form.relation | showRelation }})</span>
                </el-form-item>
                <el-form-item label="电话：" prop="phone">
                    {{ form.phone }}
                </el-form-item>
                <el-form-item label="性别：" prop="">
                    {{ form.sex | showSex }}
                </el-form-item>

                <el-form-item label="所在地：" prop="">
                    {{ form | showLocation }}
                </el-form-item>
                <el-form-item label="就诊医院：" prop="">
                    {{ form.hospital }}
                </el-form-item>
                <el-form-item label="就诊医生：" prop="">
                    {{ form.doctor_name }}
                </el-form-item>
                <el-form-item label="医生科室：" prop="">
                    {{ form.department }}
                </el-form-item>
                <el-form-item label="关注领域：" prop="">
                    {{ form.tumour }}
                </el-form-item>
                <el-form-item label="发票：" prop="">
                    <el-image
                            v-if="form.invoice_path"
                            style="width: 100px; height: 100px"
                            :src="`https://tumorxd.oss-cn-shanghai.aliyuncs.com/${form.invoice_path}`"
                            fit="cover"
                            :preview-src-list="[
              `https://tumorxd.oss-cn-shanghai.aliyuncs.com/${form.invoice_path}`,
            ]"
                    ></el-image>
                </el-form-item>
                <el-form-item
                        :label="showFormDrugText(form.drug_code)"
                        prop=""
                        v-if="form.drug_code != 0"
                        style="margin-bottom: 10px;"
                >
                    <el-date-picker
                            v-model="form.first_drug_date"
                            type="date"
                            placeholder="选择日期"
                            @change="firstTime"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="用药：" prop="" v-else style="margin-bottom: 10px;">
                    <!-- drug_code 0:未使用 2：使用 -->
                    未使用任何药物
                </el-form-item>

                <el-form-item label="瘤种/阶段：">
                    <el-select
                            v-model="form.tumour_id"
                            class="width_220"
                            placeholder="请选择瘤种"
                            @change="changeCycle"
                    >
                        <el-option
                                v-for="(item, index) in allIllData"
                                :label="item.name"
                                :value="item.tumour_id"
                                :key="index"
                        ></el-option>
                    </el-select>
                    <span v-if="form.tumour_stage" style="width: 20px; text-align: center"> / </span>
                    <span v-if="form.tumour_stage">{{form.tumour_stage}}</span>
                    <span v-if="form.tumour_cycle" style="width: 20px; text-align: center"> / </span>
                    <span v-if="form.tumour_cycle">{{form.tumour_cycle}}</span>
                    <!--
                    <el-select
                      v-model="form.tumour_cycle_id"
                      placeholder="请选择阶段"
                      :disabled="!form.tumour_id"
                      class="width_120"
                    >
                      <el-option
                        v-for="(item, index) in cycleList"
                        :label="item.name"
                        :value="item.tumour_cycle_id"
                        :key="index"
                      ></el-option>
                    </el-select>-->
                </el-form-item>
                <el-form-item style="margin-top: 15px">
                    <el-button type="primary" @click="submit">审核通过</el-button>
                    <el-button type="danger" @click="dialogTableVisible = true">拒绝</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-dialog
                title="拒绝理由"
                :visible.sync="dialogTableVisible"
                :modal-append-to-body="false"
        >
            <el-table :data="tableData" @current-change="handleCurrentChange">
                <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                <el-table-column width="50">
                    <input type="checkbox" name="" id="" slot-scope="scope" v-model="scope.row.checked">
                </el-table-column>
                <el-table-column prop="reason" label="拒绝理由">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;">
                            <template v-if="scope.row.id == 8">
                                <!-- v-if="scope.row.id == 8 && scope.row.checked" -->
                                {{scope.row.reason}}
                                <el-input v-model="scope.row.value" :disabled="!scope.row.checked" placeholder="请输入拒绝理由"
                                          style="width: 80%;"></el-input>
                            </template>
                            <template v-else>{{scope.row.reason}}</template>
                        </div>
                    </template>
                    <!-- <template slot-scope="scope">
                    {{scope.row.id == 8 && scope.row.checked}}

                    </template> -->
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="refuse">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import address from "../../assets/json/adress.json";
    import {clone} from "../../global/utils";
    import {aliyunImgurl} from "../../global/config"

    export default {
        name: "ill",
        data() {
            const checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error("请输入手机号！"));
                }
                let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error("请输入正确的手机号！"));
                }
            };
            const checkIdcard = (rule, value, callback) => {
                if (!value) {
                    callback();
                }
                let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error("请输入正确的身份证号！"));
                }
            };
            const checkNum = (rule, value, callback) => {
                if (!value) {
                    callback();
                }
                let reg = /^[0-9]*$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error("请输入数字！"));
                }
            };
            return {
                dialogTableVisible: false,
                currentRow: null,
                form: {
                    name: "",
                    phone: "",

                    sex: "",
                    iid: "",
                    birth: "",

                    tumour_id: "",
                    tumour_cycle_id: "",

                    hospital: "",
                    relation: "",

                    address: "",
                },
                rules: {
                    name: [{required: true, message: "请输入姓名！", trigger: "blur"}],
                    tumour_cycle_id: [
                        {required: true, message: "请选择瘤种！", trigger: "blur"},
                    ],
                    phone: [{required: true, validator: checkPhone, trigger: "blur"}],
                    iid: [{required: false, validator: checkIdcard, trigger: "blur"}],
                },
                pickerOptions: {
                    // disabledDate(time) {
                    //     return time.getTime() > (new Date()).getTime()
                    // }
                    // 未生效
                },

                sexList: [
                    {name: "男", value: "1"},
                    {name: "女", value: "2"},
                ],
                marriageList: [
                    {name: "已婚", value: "1"},
                    {name: "未婚", value: "2"},
                ],
                stageList: [],
                drugList: [
                    {
                        name: '信迪利单抗',
                        value: 1
                    },
                    {
                        name: '佩米替尼',
                        value: 2
                    },
                    {
                        name: '以上药物均未使用',
                        value: 0
                    }
                ],

                address_options: address,
                address_props: {
                    value: "label",
                },
                address_list: [],

                ill_props: {
                    value: "tumour_cycle_id",
                    label: "name",
                    children: "cycle_list",
                },
                tableData: [
                    {
                        id: 1,
                        checked: false,
                        reason: "发票图片无法识别，请重新拍照上传",
                    },
                    {
                        id: 2,
                        checked: false,
                        reason: "发票号码查验有误，请提供正确的发票",
                    },
                    {
                        id: 3,
                        checked: false,
                        reason: "发票日期不符合标准，请提供日期为2022年1月1日以后的发票",
                    },
                    {
                        id: 4,
                        checked: false,
                        reason:
                            "发票名称与注册用户姓名不一致，请提供与注册用户姓名一致的发票",
                    },
                    {
                        id: 5,
                        checked: false,
                        reason: "发票内容未含达伯舒（信迪利单抗注射液），请提供正确的发票",
                    },
                    {
                        id: 6,
                        checked: false,
                        reason: "此发票重复提交，请更换发票",
                    },
                    {
                        id: 7,
                        checked: false,
                        reason: "该用户和手机号已被注册，不能重复注册",
                    },
                    {
                        id: 8,
                        checked: false,
                        value: '',
                        reason: "其他（请备注）",
                    },
                ],
            };
        },
        computed: {
            ...mapState("illuserData", ["selectRow", "viewTitle"]),
            ...mapState("comInformationData", ["allIllData"]),
            tumour_list() {
                let list = clone(this.allIllData);
                list.map((v) => {
                    v.tumour_cycle_id = v.tumour_id;
                });
                console.log(list)
                return list;
            },
            cycleList() {
                let list = this.allIllData.find(l => l.tumour_id == this.form.tumour_id)
                return list && list.cycle_list || [];
            }
        },
        filters: {
            showSex(val) {
                return val == 1 ? "男" : val == 2 ? "女" : "无";
            },
            showLocation(val) {
                if (val.province == val.city) {
                    return `${val.city}/${val.region}`;
                }
                return `${val.province}/${val.city}`;
            },
            showMarriage(val) {
                return val == 1 ? "已婚" : val == 2 ? "未婚" : "无";
            },
            showRelation(val) {
                let list = [
                    {name: "本人", value: "1"},
                    {name: "家属", value: "2"},
                    {name: "朋友", value: "3"},
                    {name: "医助", value: "4"},
                ];
                let item = list.filter((e) => e.value == val);
                if (item && item.length > 0) {
                    return item[0].name;
                } else {
                    return "";
                }
            },
        },
        mounted() {
            this.form = clone(this.selectRow);
            this.getCalcStage()
        },
        methods: {
            showFormDrugText(drug_code) {
                let text = '';
                this.drugList.map(v => {
                    if (v.value == drug_code) {
                        text = `首次使用${v.name}时间：`
                    }
                });
                return text
            },
            handleCurrentChange(val) {
                console.log(val);
                this.currentRow = val;
                this.tableData.forEach((data, index) => {
                    if (data.id !== val.id) {
                        data.checked = false;
                    } else {
                        data.checked = true;
                    }
                    this.$set(this.tableData, index, data)
                });
                this.$forceUpdate()
            },
            changeCycle(val) {
                //    改变时间和病种后重新计算阶段和分期
                let data = this.allIllData.find((l) => l.tumour_id == val);
                // console.log('----',val,data);
                // this.stageList = data.stage_list;
                this.getCalcStage()
            },
            firstTime() {
                //    改变时间和病种后重新计算阶段和分期
                this.getCalcStage()
            },
            getCalcStage() {
                let params = {
                    first_drug_date: this.form.first_drug_date,
                    tumour_id: this.form.tumour_id
                };
                this.httpGet('/admin/patient/check_tumour_stage', params).then(res => {
                    this.$set(this.form, 'tumour_stage', res.data.stage.name);
                    this.$set(this.form, 'tumour_cycle', res.data.cycle.name);
                    this.form.tumour_stage_id = res.data.stage.cycle_id;
                    this.form.tumour_cycle_id = res.data.cycle.cycle_id;
                    console.log(this.form.tumour_stage, this.form.tumour_cycle);
                })
            },

            handleChange(val) {
                this.form.address_province = val[0];
                this.form.address_city = val[1];
                this.form.address_region = val[2];
            },
            handleChangeIll(val) {
                console.log(val, "296");
                this.form.tumour_id = val[0];
                this.form.tumour_cycle_id = val[1];
            },
            goBack() {
                this.$emit("changeTopTab", "tableView");
            },
            submit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        console.log(valid);
                        this.submitUpdate();
                    }
                });
            },
            refuse() {
                let list = this.tableData.find(l => l.checked);
                if (!list) {
                    this.$message('请选择拒绝理由');
                    return;
                }
                if (list.id == 8) {
                    if (!list.value) {
                        this.$message({
                            message: '请备注其他理由',
                            type: 'warning'
                        });
                        return
                    }
                }
                let url = "/user/patient/" + this.form.patient_id;
                let params = {
                    status: 4,
                    reason: list.reason
                };
                // 1 已注册 2 未审核 3 已审核 4 审核不通过
                this.httpPut(url, params)
                    .then((res) => {
                        this.$message.success("拒绝患者成功！");
                        this.goBack();
                    })
                    .catch((err) => {
                        this.$message.error(err.msg);
                    });
            },
            submitAdd() {
                let url = "/nurse/patient";
                let params = {
                    ...this.form,
                };
                this.httpPost(url, params)
                    .then((res) => {
                        this.$message.success("添加患者成功！");
                        this.goBack();
                    })
                    .catch((err) => {
                        this.$message.error(err.msg);
                    });
            },
            submitUpdate() {
                let url = "/user/patient/" + this.form.patient_id;
                let params = {
                    tumour_id: this.form.tumour_id,
                    tumour_cycle_id: this.form.tumour_cycle_id,
                    status: 3,
                };
                this.httpPut(url, params)
                    .then((res) => {
                        this.$message.success("审核患者成功！");
                        this.goBack();
                    })
                    .catch((err) => {
                        this.$message.error(err.msg);
                    });
            },
        },
    };
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            /*color: #8d8d8d;*/
            .title {
            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }

        .form_box {
            box-sizing: border-box;
            padding-top: 10px;
            background: #fff;
            height: calc(100% - 50px);
        }
        .form_look_box {
            padding: 10px;
            background: #fff;
            height: calc(100% - 50px);
            width: 100%;
            box-sizing: border-box;
            .title_box {
                width: 100%;
                height: 40px;
                line-height: 40px;
                background-color: #eceff4;
                padding: 0 20px;
                font-size: 14px;
                box-sizing: border-box;
            }
            .user_box {
                padding: 10px 20px;
                box-sizing: border-box;
                .msg_item {
                    height: 40px;
                    line-height: 40px;
                    display: flex;
                    .title {
                        width: 100px;
                        text-align: right;
                        padding: 0 10px;
                    }
                    .text {
                    }
                }
            }
            .user_msg {
                display: flex;
                .left_box {
                    flex: 0 0 300px;
                }
                .right_box {
                    flex: 1;
                    img {
                        width: 80px;
                        height: 80px;
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .ill_form_box .el-form-item {
        margin-bottom: 0;
    }

    .el-table__body tr.current-row > td.el-table__cell {
        background-color: #98c9ff;
    }
</style>